import Typography from '@components/std-components/Typography'
import { CellItem } from '@components/UI-Components/HierarchyWiseItemsTable/components/Row/Cell'
import ViewContext from '@modules/order/contexts/view-context'
import formatNumberByLocale from '@utils/format-number-by-locale'
import get from 'lodash/result'
import React, { FC, useContext } from 'react'
import FieldSkeleton from '../../../CellLoaders/FieldSkeleton'
import HierarchyCell from '../../components/HierarchyCell'

const GenericField: FC<CellItem> = ({ rowData, column }) => {
  const {
    uiStore: { getHierarchy }
  } = useContext(ViewContext)
  if (!rowData) {
    return (
      <HierarchyCell>
        <FieldSkeleton />
      </HierarchyCell>
    )
  }
  const hierarchy = rowData?.name ? getHierarchy(rowData?.name) : []
  const val = get(hierarchy?.[hierarchy?.length - 1], column?.field)
  return (
    <HierarchyCell>
      <Typography variant='subHeading1'>
        {typeof val === 'string'
          ? val || '-'
          : formatNumberByLocale(val as number) || '-'}
      </Typography>
    </HierarchyCell>
  )
}

export default GenericField
